import firebase from 'firebase/compat/app';

import { FirebaseTimestamp } from '@/models';

import 'firebase/compat/firestore';

export function convertDate(timestamp: FirebaseTimestamp | { seconds: number; nanoseconds: number }) {
  // Ensure the timestamp is a Firestore Timestamp, if not reconstruct it
  const firestoreTimestamp =
    timestamp instanceof firebase.firestore.Timestamp
      ? timestamp
      : new firebase.firestore.Timestamp(timestamp.seconds, timestamp.nanoseconds);

  const dateObject = firestoreTimestamp.toDate();

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(dateObject);
}
